var vskoDatePicker = angular.module('vskoDatePicker', []);

vskoDatePicker.directive('vskoDatePicker', [function () {
  'use strict';

  return {
    restrict: 'E',
    template: require('./vsko-date-picker.html'),
    required: ['ngModel'],
    scope: {
      format: '@?',
      ngDisabled: '=',
      ngModel: '=',
      ngRequired: '=',
      options: '=?',
      placeholder: '@',
      changed: '&'
    },
    link: function ($scope, element, attrs) {
      $scope.pickerModel = {
        opened: false
      };

      $scope.open = function () {
        $scope.pickerModel.opened = true;
      };

      $scope.change = function () {
        if ($scope.changed) {
          if ($scope.timeout) {
            clearTimeout($scope.timeout)
          }

          $scope.timeout = setTimeout(function () {
            if ($scope.ngModel !== undefined) {
              $scope.changed();
            }
          }, 300);
        }
      };
    }
  }
}]);
